import _regeneratorRuntime from 'babel-runtime/regenerator';
import _Promise from 'babel-runtime/core-js/promise';
import _extends from 'babel-runtime/helpers/extends';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import ArbitrableJSONInterface from '@kleros/kleros-interaction/build/contracts/Arbitrable';
import * as errorConstants from '../constants/error';
import EventListener from '../utils/EventListener';
import isRequired from '../utils/isRequired';
import { validateFileFromURI } from '../utils/hashing';
import { getHttpUri } from '../utils/uri';
import StandardContract from './StandardContract';
/**
 * Provides interaction with standard Arbitrable contracts
 * @example
 * const arbitrable = new Arbitable(web3Provider)
 */

var Arbitrable = function (_StandardContract) {
  _inherits(Arbitrable, _StandardContract);

  function Arbitrable() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Arbitrable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Arbitrable.__proto__ || _Object$getPrototypeOf(Arbitrable)).call.apply(_ref, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
  }
  /**
   * Load an arbitrable web3 contract instance
   * @param {string} contractAddress - Address of the Arbitrable contract.
   * @returns {object} web3 contract instance
   */

  /**
   * Fetch all Evidence submitted to the contract.
   * @param {string} contractAddress - The address of the arbitrable contract.
   * @param {string} arbitratorAddress - The address of the arbitrator contract.
   * @param {number} evidenceGroupID - The index of the evidence group.
   * @param {object} options - Additional paramaters. Includes fromBlock, toBlock, filters, strictHashes
   * @returns {object[]} An array of evidence objects
   */

  /**
   * Get the MetaEvidence object for a metaEvidenceID. Hashes will be validated.
   * By default MetaEvidence will be returned regardless of the validity of the hashes
   * with an indicator on whether the hash was valid or not. To throw an error instead,
   * use strictHashes = true in options object.
   * NOTE: If more than one MetaEvidence with the same metaEvidenceID is found it will return the 1st one.
   * @param {string} contractAddress - The address of the Arbitrable contract.
   * @param {number} metaEvidenceID - The identifier of the metaEvidence log.
   * @param {object} options - Additional paramaters. Includes fromBlock, toBlock, strictHashes
   * @returns {object} The metaEvidence object
   */

  /**
   * Fetch the ruling for a dispute.
   * @param {string} contractAddress - The address of the arbitrable contract.
   * @param {string} arbitratorAddress - The address of the arbitrator contract.
   * @param {number} disputeID - The index of the dispute.
   * @param {object} options - Optional parameters. Includes fromBlock and toBlock.
   * @returns {number} The number denoting the ruling.
   */

  /**
   * Get the event log emitted when a dispute has been created. This event links
   * metaEvidence to a dispute by _metaEvidenceID.
   * @param {string} contractAddress - The address of the contract.
   * @param {string} arbitratorAddress - The address of the arbitrator contract.
   * @param {number} disputeID - The index of the dispute.
   * @param {object} options - Optional parameters. Includes fromBlock and toBlock.
   * @returns {object} The data from the event log
   */


  return Arbitrable;
}(StandardContract);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this._loadContractInstance = function (contractAddress) {
    return new _this2.web3.eth.Contract(ArbitrableJSONInterface.abi, contractAddress);
  };

  this.getEvidence = function () {
    var _ref2 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2() {
      var contractAddress = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : isRequired('contractAddress');
      var arbitratorAddress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : isRequired('arbitratorAddress');
      var evidenceGroupID = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : isRequired('evidenceGroupID');
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var contractInstance, evidenceLogs;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              contractInstance = _this2._loadContractInstance(contractAddress);
              _context2.next = 3;
              return EventListener.getEventLogs(contractInstance, 'Evidence', options.fromBlock || 0, options.toBlock || 'latest', _extends({
                _arbitrator: arbitratorAddress,
                _evidenceGroupID: evidenceGroupID.toString()
              }, options.filters));

            case 3:
              evidenceLogs = _context2.sent;

              if (!(evidenceLogs.length === 0)) {
                _context2.next = 6;
                break;
              }

              return _context2.abrupt('return', []);

            case 6:
              return _context2.abrupt('return', _Promise.all(evidenceLogs.map(function () {
                var _ref3 = _asyncToGenerator(
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _callee(evidenceLog) {
                  var args, _getHttpUri, evidenceURI, preValidated, _ref4, evidenceJSON, evidenceJSONValid, fileValid, _getHttpUri2, _evidenceURI, _preValidated, submittedAt;

                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return evidenceLog.returnValues;

                        case 2:
                          args = _context.sent;
                          _getHttpUri = getHttpUri(args._evidence, _this2.ipfsGateway), evidenceURI = _getHttpUri.uri, preValidated = _getHttpUri.preValidated;
                          _context.next = 6;
                          return validateFileFromURI(evidenceURI, {
                            preValidated: preValidated,
                            strictHashes: options.strictHashes,
                            customHashFn: options.customHashFn
                          });

                        case 6:
                          _ref4 = _context.sent;
                          evidenceJSON = _ref4.file;
                          evidenceJSONValid = _ref4.isValid;
                          fileValid = false;
                          _context.prev = 10;

                          if (!evidenceJSON.fileURI) {
                            _context.next = 16;
                            break;
                          }

                          _getHttpUri2 = getHttpUri(evidenceJSON.fileURI, _this2.ipfsGateway), _evidenceURI = _getHttpUri2.uri, _preValidated = _getHttpUri2.preValidated;
                          _context.next = 15;
                          return validateFileFromURI(_evidenceURI, {
                            preValidated: _preValidated,
                            strictHashes: options.strictHashes,
                            hash: evidenceJSON.fileHash,
                            customHashFn: options.customHashFn
                          });

                        case 15:
                          fileValid = _context.sent.isValid;

                        case 16:
                          _context.next = 22;
                          break;

                        case 18:
                          _context.prev = 18;
                          _context.t0 = _context['catch'](10);

                          if (!options.strictHashes) {
                            _context.next = 22;
                            break;
                          }

                          throw new Error(_context.t0);

                        case 22:
                          _context.next = 24;
                          return new _Promise(function (resolve, reject) {
                            _this2.web3.eth.getBlock(evidenceLog.blockNumber, function (error, result) {
                              if (error) reject(error);
                              resolve(result);
                            });
                          });

                        case 24:
                          submittedAt = _context.sent.timestamp;
                          return _context.abrupt('return', {
                            evidenceJSONValid: evidenceJSONValid,
                            fileValid: fileValid,
                            evidenceJSON: evidenceJSON,
                            submittedAt: submittedAt,
                            submittedBy: args._party,
                            blockNumber: evidenceLog.blockNumber,
                            transactionHash: evidenceLog.transactionHash
                          });

                        case 26:
                        case 'end':
                          return _context.stop();
                      }
                    }
                  }, _callee, _this2, [[10, 18]]);
                }));

                return function (_x5) {
                  return _ref3.apply(this, arguments);
                };
              }())));

            case 7:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }));

    return function () {
      return _ref2.apply(this, arguments);
    };
  }();

  this.getMetaEvidence = function () {
    var _ref5 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee3() {
      var contractAddress = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : isRequired('contractAddress');
      var metaEvidenceID = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : isRequired('metaEvidenceID');
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var contractInstance, metaEvidenceLogs, metaEvidenceLog, args, _getHttpUri3, metaEvidenceUri, preValidated, _ref6, metaEvidenceJSON, metaEvidenceJSONValid, fileValid, _getHttpUri4, fileURI, _preValidated2, interfaceValid, _getHttpUri5, disputeInterfaceURI, _preValidated3;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              contractInstance = _this2._loadContractInstance(contractAddress);
              _context3.next = 3;
              return EventListener.getEventLogs(contractInstance, 'MetaEvidence', options.fromBlock || 0, options.toBlock || 'latest', _extends({
                _metaEvidenceID: metaEvidenceID.toString()
              }, options.filters));

            case 3:
              metaEvidenceLogs = _context3.sent;

              if (metaEvidenceLogs[0]) {
                _context3.next = 6;
                break;
              }

              throw new Error(errorConstants.CONTRACT_ERROR('No MetaEvidence log for ' + contractAddress + ' with metaEvidenceID ' + metaEvidenceID));

            case 6:
              metaEvidenceLog = metaEvidenceLogs[0];
              _context3.next = 9;
              return metaEvidenceLog.returnValues;

            case 9:
              args = _context3.sent;
              _getHttpUri3 = getHttpUri(args._evidence, _this2.ipfsGateway), metaEvidenceUri = _getHttpUri3.uri, preValidated = _getHttpUri3.preValidated;
              _context3.next = 13;
              return validateFileFromURI(metaEvidenceUri, {
                preValidated: preValidated,
                strictHashes: options.strictHashes,
                customHashFn: options.customHashFn
              });

            case 13:
              _ref6 = _context3.sent;
              metaEvidenceJSON = _ref6.file;
              metaEvidenceJSONValid = _ref6.isValid;
              fileValid = false;
              _context3.prev = 17;

              if (!metaEvidenceJSON.fileURI) {
                _context3.next = 23;
                break;
              }

              _getHttpUri4 = getHttpUri(metaEvidenceJSON.fileURI, _this2.ipfsGateway), fileURI = _getHttpUri4.uri, _preValidated2 = _getHttpUri4.preValidated;
              _context3.next = 22;
              return validateFileFromURI(fileURI, {
                preValidated: _preValidated2,
                strictHashes: options.strictHashes,
                hash: metaEvidenceJSON.fileHash,
                customHashFn: options.customHashFn
              });

            case 22:
              fileValid = _context3.sent.isValid;

            case 23:
              _context3.next = 29;
              break;

            case 25:
              _context3.prev = 25;
              _context3.t0 = _context3['catch'](17);

              if (!options.strictHashes) {
                _context3.next = 29;
                break;
              }

              throw new Error(_context3.t0);

            case 29:
              // validate file hash
              interfaceValid = void 0;
              _context3.prev = 30;

              if (!metaEvidenceJSON.evidenceDisplayInterfaceURL) {
                _context3.next = 40;
                break;
              }

              _getHttpUri5 = getHttpUri(metaEvidenceJSON.evidenceDisplayInterfaceURL, _this2.ipfsGateway), disputeInterfaceURI = _getHttpUri5.uri, _preValidated3 = _getHttpUri5.preValidated;

              if (!_preValidated3) {
                _context3.next = 37;
                break;
              }

              interfaceValid = true;
              _context3.next = 40;
              break;

            case 37:
              _context3.next = 39;
              return validateFileFromURI(disputeInterfaceURI, {
                strictHashes: options.strictHashes,
                hash: metaEvidenceJSON.evidenceDisplayInterfaceHash,
                customHashFn: options.customHashFn
              });

            case 39:
              interfaceValid = _context3.sent.isValid;

            case 40:
              _context3.next = 47;
              break;

            case 42:
              _context3.prev = 42;
              _context3.t1 = _context3['catch'](30);

              if (!options.strictHashes) {
                _context3.next = 46;
                break;
              }

              throw new Error(_context3.t1);

            case 46:
              interfaceValid = false;

            case 47:
              return _context3.abrupt('return', {
                metaEvidenceJSON: metaEvidenceJSON,
                metaEvidenceJSONValid: metaEvidenceJSONValid,
                fileValid: fileValid,
                interfaceValid: interfaceValid,
                blockNumber: metaEvidenceLog.blockNumber,
                transactionHash: metaEvidenceLog.transactionHash
              });

            case 48:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this2, [[17, 25], [30, 42]]);
    }));

    return function () {
      return _ref5.apply(this, arguments);
    };
  }();

  this.getRuling = function () {
    var _ref7 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee4() {
      var contractAddress = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : isRequired('contractAddress');
      var arbitratorAddress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : isRequired('arbitratorAddress');
      var disputeID = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : isRequired('disputeID');
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var contractInstance, rulingLogs, rulingLog, args, ruledAt;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              contractInstance = _this2._loadContractInstance(contractAddress);
              _context4.next = 3;
              return EventListener.getEventLogs(contractInstance, 'Ruling', options.fromBlock || 0, options.toBlock || 'latest', _extends({
                _arbitrator: arbitratorAddress,
                _disputeID: disputeID.toString()
              }, options.filters));

            case 3:
              rulingLogs = _context4.sent;

              if (!(rulingLogs.length === 0)) {
                _context4.next = 8;
                break;
              }

              throw new Error(errorConstants.CONTRACT_ERROR('There is no ruling for dispute ' + disputeID + ' in arbitrator ' + arbitratorAddress));

            case 8:
              if (!(rulingLogs.length > 1)) {
                _context4.next = 10;
                break;
              }

              throw new Error(errorConstants.CONTRACT_ERROR('There is more than one ruling for dispute ' + disputeID + ' in arbitrator ' + arbitratorAddress));

            case 10:
              rulingLog = rulingLogs[0];
              _context4.next = 13;
              return rulingLog.returnValues;

            case 13:
              args = _context4.sent;
              _context4.next = 16;
              return new _Promise(function (resolve, reject) {
                _this2.web3.eth.getBlock(rulingLog.blockNumber, function (error, result) {
                  if (error) reject(error);
                  resolve(result);
                });
              });

            case 16:
              ruledAt = _context4.sent.timestamp;
              return _context4.abrupt('return', {
                ruling: args._ruling,
                ruledAt: ruledAt,
                blockNumber: rulingLog.blockNumber,
                transactionHash: rulingLog.transactionHash
              });

            case 18:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this2);
    }));

    return function () {
      return _ref7.apply(this, arguments);
    };
  }();

  this.getDispute = function () {
    var _ref8 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee5() {
      var contractAddress = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : isRequired('contractAddress');
      var arbitratorAddress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : isRequired('arbitratorAddress');
      var disputeID = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : isRequired('isRequired');
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var contractInstance, disputeLogs, disputeLog, args, createdAt;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              contractInstance = _this2._loadContractInstance(contractAddress);
              _context5.next = 3;
              return EventListener.getEventLogs(contractInstance, 'Dispute', options.fromBlock || 0, options.toBlock || 'latest', _extends({
                _arbitrator: arbitratorAddress,
                _disputeID: disputeID.toString()
              }, options.filters));

            case 3:
              disputeLogs = _context5.sent;

              if (!(disputeLogs.length === 0)) {
                _context5.next = 6;
                break;
              }

              throw new Error(errorConstants.CONTRACT_ERROR('No Dispute log for ' + contractAddress + ' with arbitrator ' + arbitratorAddress + ' and disputeID ' + disputeID));

            case 6:
              if (!(disputeLogs.length > 1)) {
                _context5.next = 8;
                break;
              }

              throw new Error(errorConstants.CONTRACT_ERROR('More than one Dispute returned for arbitrator ' + arbitratorAddress + ' and disputeID ' + disputeID));

            case 8:
              disputeLog = disputeLogs[0];
              _context5.next = 11;
              return disputeLog.returnValues;

            case 11:
              args = _context5.sent;
              _context5.next = 14;
              return new _Promise(function (resolve, reject) {
                _this2.web3.eth.getBlock(disputeLog.blockNumber, function (error, result) {
                  if (error) reject(error);
                  resolve(result);
                });
              });

            case 14:
              createdAt = _context5.sent.timestamp;
              return _context5.abrupt('return', {
                metaEvidenceID: args._metaEvidenceID,
                evidenceGroupID: args._evidenceGroupID,
                createdAt: createdAt,
                blockNumber: disputeLog.blockNumber,
                transactionHash: disputeLog.transactionHash
              });

            case 16:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this2);
    }));

    return function () {
      return _ref8.apply(this, arguments);
    };
  }();
};

export default Arbitrable;